import { Drawer, Box, Typography, IconButton } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
// New component with thread lanes visualization
import { ShipmentTimelineWithThreadLines } from "../../shipments/ShipmentTimelineComponent";
// Old component (commented out - kept for reference):
// import { ShipmentTimeline } from "../../shipments/ShipmentTimeline";
import type { ShipmentUpdate, EmailSource } from "../../shipments/ShipmentDetails";

interface TimelineSidePanelProps {
  open: boolean;
  onClose: () => void;
  shipmentId?: string;
  updates?: ShipmentUpdate[];
  emailSource?: EmailSource;
  includeInternalReminders?: boolean;
}

export function TimelineSidePanel({
  open,
  onClose,
  shipmentId,
  updates,
  emailSource,
  includeInternalReminders,
}: TimelineSidePanelProps) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      slotProps={{
        paper: { sx: { width: 780, display: "flex", flexDirection: "column" } },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          py: 0.5,
          px: 2,
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Content - Use ShipmentTimelineWithThreadLines (new component with colored lanes) */}
      <Box sx={{ flex: 1, overflow: "hidden" }}>
        {shipmentId && (
          <ShipmentTimelineWithThreadLines
            shipmentId={shipmentId}
            updates={updates}
            emailSource={emailSource}
            includeInternalReminders={includeInternalReminders}
          />
        )}
        {/* Old component (commented out - kept for reference):
        {shipmentId && (
          <ShipmentTimeline
            shipmentId={shipmentId}
            updates={updates}
            emailSource={emailSource}
            includeInternalReminders={includeInternalReminders}
          />
        )}
        */}
      </Box>
    </Drawer>
  );
}
